import { ICONS, faClass } from '@/constants/icons';

import s from './Empty.module.scss';

/**
 * Stato vuoto — usare al posto di una vista priva di dati.
 *
 * @param {object} props
 * @param {string} [props.icon=ICONS.empty] — `ICONS.x`, classe FA completa o glifo nudo
 * @param {string} props.title
 * @param {string} [props.message]
 * @param {React.ReactNode} [props.action] — CTA opzionale (es. <Button>)
 */
export default function Empty({ icon = ICONS.empty, title, message, action }) {
  return (
    <div className={s.root} role="status">
      <i className={faClass(icon, s.icon)} aria-hidden="true" />
      <p className={s.title}>{title}</p>
      {message ? <p className={s.message}>{message}</p> : null}
      {action ? <div className={s.action}>{action}</div> : null}
    </div>
  );
}
